import React from 'react';

export type IncidentStatus = 'new' | 'investigating' | 'contained' | 'resolved' | 'closed';
export type AssetStatus = 'online' | 'degraded' | 'offline' | 'quarantined';
export type AlertStatus = 'triggered' | 'acknowledged' | 'suppressed' | 'escalated';

type AnyStatus = IncidentStatus | AssetStatus | AlertStatus;

const statusConfig: Record<string, { label: string; classes: string }> = {
  new: { label: 'New', classes: 'bg-red-500/15 text-red-400 border border-red-500/20' },
  investigating: { label: 'Investigating', classes: 'bg-amber-500/15 text-amber-400 border border-amber-500/20' },
  contained: { label: 'Contained', classes: 'bg-blue-500/15 text-blue-400 border border-blue-500/20' },
  resolved: { label: 'Resolved', classes: 'bg-emerald-500/15 text-emerald-400 border border-emerald-500/20' },
  closed: { label: 'Closed', classes: 'bg-zinc-700/50 text-zinc-500 border border-zinc-700' },
  online: { label: 'Online', classes: 'bg-emerald-500/15 text-emerald-400 border border-emerald-500/20' },
  degraded: { label: 'Degraded', classes: 'bg-amber-500/15 text-amber-400 border border-amber-500/20' },
  offline: { label: 'Offline', classes: 'bg-red-500/15 text-red-400 border border-red-500/20' },
  quarantined: { label: 'Quarantined', classes: 'bg-purple-500/15 text-purple-400 border border-purple-500/20' },
  triggered: { label: 'Triggered', classes: 'bg-red-500/15 text-red-400 border border-red-500/20' },
  acknowledged: { label: 'Acknowledged', classes: 'bg-blue-500/15 text-blue-400 border border-blue-500/20' },
  suppressed: { label: 'Suppressed', classes: 'bg-zinc-700/50 text-zinc-500 border border-zinc-700' },
  escalated: { label: 'Escalated', classes: 'bg-purple-500/15 text-purple-400 border border-purple-500/20' },
};

interface StatusBadgeProps {
  status: AnyStatus;
  size?: 'sm' | 'md';
}

export default function StatusBadge({ status, size = 'sm' }: StatusBadgeProps) {
  const cfg = statusConfig[status] ?? { label: status, classes: 'bg-zinc-700/50 text-zinc-400 border border-zinc-700' };
  const sizeClasses = size === 'sm' ? 'text-[10px] px-1.5 py-0.5' : 'text-xs px-2 py-1';

  return (
    <span className={`inline-flex items-center rounded font-semibold uppercase tracking-wide ${cfg.classes} ${sizeClasses}`}>
      {cfg.label}
    </span>
  );
}